import { ActionTree } from 'vuex'
import { PrintedDocumentState } from '@/store/printedDocuments/index'
import { RootState } from '@/store'
import { PrintedDocumentAPI } from '@/api/backend-client'

export const actions: ActionTree<PrintedDocumentState, RootState> = {
    async fetchData({ getters, commit }): Promise<void> {
        try {
            commit('fetchData')
            commit('fetchDataSuccess', await PrintedDocumentAPI.getPaged(getters.requestParams))
        } catch (error) {
            commit('fetchDataFailure', error)
        }
    },

    async setPage({ commit, dispatch}, payload: { page: number }): Promise<void> {
        commit('setPage', payload)
        dispatch('fetchData')
    },

    async nextPage({ state, commit, dispatch }): Promise<void> {
        commit('setPage', { page: state.page + 1 })
        dispatch('fetchData')
    },

    async prevPage({ state, commit, dispatch }): Promise<void> {
        commit('setPage', { page: state.page - 1 })
        dispatch('fetchData')
    },

    async applyOrder({ commit, dispatch }, payload: { field: string, direction: string}): Promise<void> {
        commit('applyOrder', payload)
        commit('setPage', { page: 1})
        dispatch('fetchData')
    },

    async applyCompanyFilter({ commit, dispatch }, payload: { query: string}): Promise<void> {
        commit('applyCompanyFilter', payload)
        commit('setPage', { page: 1 })
        dispatch('fetchData')
    },
}
